define([
	"dojo/_base/declare",
	"csi/heading/Number",
	"csi/util",
	"../SizeChart"
], function(declare,NumberRen,util,SizeChart) {

	var _conversionFactors = {
		"Size Chart Units:IN - Fraction" : 1.0 / 2.54,
		"Size Chart Units:IN - Decimal": 1.0 / 2.54,
		"Size Chart Units:MM": 10.0
	};

	return declare(NumberRen, {
		DEFAULT: -999.0,

		formatValue: function(/*Any*/value, /*String?*/fmt) {
			// summary: handle default value
			return SizeChart.isNotInitialized(value) ? "" : this.inherited(arguments);
		},

		getQuerySpec: function(/*Context*/ctx, /*Heading*/h, /*Spec*/spec) {
			// summary: do not all sorting or filtering on any SizeChart numbers
			return null;
		},

		isAbsoluteDisplay: function(/*Context*/ctx) {
			// summary: return if currently displaying absolute values
			return ctx.view.sizeChartDisplay == "Size Chart Display:Absolute";
		},

		isIncrementDisplay: function(/*Context*/ctx) {
			// summary: return if currently displaying increment values
			return ctx.view.sizeChartDisplay == "Size Chart Display:Increment";
		},

		isRelativeDisplay: function(/*Context*/ctx) {
			// summary: return if currently displaying relative increment values
			return ctx.view.sizeChartDisplay == "Size Chart Display:Relative";
		},

		_applyFactor: function(/*Context*/ctx, /*Number*/value) {
			// summary: convert value to inches, and then to configured fraction of inches if displaying fractions
			if (SizeChart.isNotInitialized(value)) {
				return value;
			}

			var	v = this.inherited(arguments);

			if (v && this._isFraction(ctx)) {
				v = SizeChart.roundToFraction(v);
			}

			return v;
    	},

		_equal: function(/*Number*/n1, /*Number*/n2, /*Number?*/tol) {
			// summary: return if two numbers are equal to 4 decimal places
			var	d = Math.abs(n1 - n2);
			return (tol == null) ? (d < 0.001) : (util.truncate(d, 0.0001) <= util.truncate(tol, 0.0001));
		},

		_gap: function(/*Number*/n1, /*Number*/n2) {
			// summary: return difference between two numbers up to 3 decimal places
			var	d = SizeChart.sumDoubleValues(n1, -n2);
			return (Math.abs(d) < 0.0005) ? 0.0 : d;
		},

		_getFactor: function(/*Context*/ctx) {
			// summary: return conversion factor from cm to mm or inches
			return _conversionFactors[ctx.view.sizeChartUnits];
		},

		_isFraction: function(/*Context*/ctx) {
			// summary: return if value should be represented as fraction
			return SizeChart.isFractionUnit(ctx.view.sizeChartUnits);
		},
	});
});